import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LookupService } from '../../../../services/lookups/lookup.service';
import { LookupAdminService } from '../../../../services/lookups/lookupadmin.service';
import {Location} from '../../../../models/user.model';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-programarea-detail',
  templateUrl: './programarea-detail.component.html',
  styleUrls: ['./programarea-detail.component.css']
})
export class ProgramAreaDetailComponent implements OnInit {
  programareas: Location[] = [];
  @Output() showHideProgramAreaDetailDlg = new EventEmitter<boolean>();
  @Output() refreshDataSource=new EventEmitter<boolean>();
  programAreaDetailForm: FormGroup;

  constructor(private fb: FormBuilder, 
              private lookupService: LookupService,
              private lookupAdminService:LookupAdminService,
              private notifier: NotifierService) {}

  ngOnInit() {
    this.programAreaDetailForm = this.fb.group({
      Id: [''],
      programAreaName: ['', [Validators.required, Validators.pattern(/^[ A-Za-z0-9_'-]*$/)]],
      //hq: [2],
      isActive:['',Validators.required],
      //lastUpdatedBy:[''],
      lastUpdatedDateTime:['']
    });
  }

  showProgramAreaDetailDialog(location: Location) {
    // console.log(id);
    //this.lookupService.getRootLocations(this.authUser._user.userType.typeName).subscribe((data: Location[]) => {
      this.lookupService.getAllProgramAreas$().subscribe((data: Location[]) => {
      this.programareas = data;
      this.programareas.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
    });
    
    if(location!=null)
    {
      console.log(location);
      this.programAreaDetailForm.patchValue({
          Id:location.id,
          programAreaName:location.locationName,
          //country:location.parentLocation,
          isActive :String(location.isActive),
          lastUpdatedDateTime : new Date(location.lastUpdatedDateTime).toLocaleString()
      });
    }
    else
    {
      this.programAreaDetailForm.reset();
    }

  }

  onCancelProgramAreaDetail()
  {
    this.programAreaDetailForm.reset();
    this.showHideProgramAreaDetailDlg.emit(false);
    this.refreshDataSource.emit(true);
  }
  onSaveProgramAreaDetail()
  {
       if(this.programAreaDetailForm.valid)
       {
         let programArea= Object.assign(new Location(),this.programAreaDetailForm.value);
         programArea.parentId = 2; // programArea.country.id;
         programArea.locationName = programArea.programAreaName;
         this.lookupAdminService.saveProgramArea(programArea).subscribe((resp)=>{
           if(resp.ok)
           {
            this.notifier.notify('success', 'Program Area saved successfully');
           }

       },error=>{
          this.notifier.notify('error', 'Failed to save Program Area, contact tech support');
          });
         
       

       }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/lookup-management/programarea/programarea-detail/programarea-detail.component.ts